module.exports = __webpack_public_path__ + "img/img3.d2f27e92.jpg";